import { Message } from '@/components'
import { UserError } from '@/graphql/generated'

const MutationErrors: React.FC<React.PropsWithChildren<{ errors?: UserError[] }>> = ({ errors }) => {
  return errors ? (
    <div className="mb-8 text-left">
      <Message type="error" isList>
        <ul className="mt-4">
          {errors.map(({ message }, index) => (
            <li className="py-1" key={index}>
              → {message}
            </li>
          ))}
        </ul>
      </Message>
    </div>
  ) : null
}

export default MutationErrors
